module.exports = __webpack_public_path__ + "static/img/u9107.a0ca988.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u9107.jpg
// module id = PoNC
// module chunks = 73